import { useSelector } from 'react-redux';
import { getGameStatusById } from '../ducks';

export const useGetBattleGameStatusById = (battleId: number) => ({
  status: useSelector(getGameStatusById(battleId)),
});
